import Ajv, { ErrorObject } from 'ajv';

const getFirstMessage = (errors: ErrorObject[]) => errors[0]?.message;

export const validateAjv = (schemaTemplate: any) => (validationObject: any) => (
  data: any
) => {
  const schema = Object.assign({}, schemaTemplate, validationObject);
  const validate = new Ajv({ strict: false }).compile(schema);

  if (validate(data)) {
    return { pass: true, message: '' };
  } else {
    return {
      pass: false,
      message: () => getFirstMessage(validate.errors!) || '',
    };
  }
};
